<template>
    <img
        v-if="url !== undefined && !profileImageHasError"
        class="usr-image"
        :src="url"
        :alt="altText || $t('Profile image')"
        @error="() => profileImageHasError = true"
    />
    <img v-else class="usr-image" src="@/assets/user.png" :alt="altText || $t('Default user profile image')" />
</template>
<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
    name: "ProfileImage",
    props: {
        url: String,
        altText: String
    },
    data() {
        return {
            profileImageHasError: false,
        }
    },
    watch: {
        url() {
            this.profileImageHasError = false;
        },
    },
})
</script>

<style scoped>
img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
    background-color: var(--user-profile-image-background);
}
</style>
